export class MapFineRule
{
    public RefId : number;
    public FineRuleName : string;
    public WorkingGroupId : number;
    public AttFineRuleId : number;
    public IsActive : boolean;
}